// default
export const PROTECTION = 'protection';
export const PROTECTION_SLICE_NAME = `${PROTECTION}Slice`;

// action
const GET_PROTECTION_LIST = `${PROTECTION}/getProtectionList`;
const DELETE_PROTECTION = `${PROTECTION}/deleteProtection`;
const CREATE_PROTECTION = `${PROTECTION}/createProtection`;
const GET_PROTECTION_LAST = `${PROTECTION}/getProtectionLast`;

// actions
export const actions = {
  GET_PROTECTION_LIST,
  DELETE_PROTECTION,
  CREATE_PROTECTION,
  GET_PROTECTION_LAST
};
